// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tool-card {
  background: #ffffff;
  border-radius: 0.75rem;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.tool-card:hover {
  transform: translateY(-0.3125rem);
  box-shadow: 0 5px 7px rgba(2, 56, 121, 0.6);
}

.card-icon {
  font-size: 2.5rem;
  color: #4a4a4a;
  margin-bottom: 0.9375rem;
}

.tool-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 0.625rem;
  text-align: justify;
}

.tool-description {
  font-size: 1rem;
  color: #2c2c2c;
  margin-bottom: 1.25rem;
  line-height: 1.3;
  text-align: left;
}

/* Button Styling */
.btn-open {
  background-color: #0060d6;
  font-size: 1rem;
  border-radius: 0.375rem;
  transition: background 0.3s ease-in-out;
}

.btn-open:hover {
  background-color: #1a1a86;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .tool-card {
    padding: 1.25rem;
  }
  .card-icon {
    font-size: 2rem;
  }
  .tool-title {
    font-size: 1.375rem;
  }
  .tool-description {
    font-size: 0.9375rem;
  }
}
@media (max-width: 576px) {
  .tool-card {
    padding: 1rem;
  }
  .card-icon {
    font-size: 1.75rem;
  }
  .tool-title {
    font-size: 1.25rem;
  }
  .tool-description {
    font-size: 0.875rem;
  }
  .btn-primary {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/digital-identity/identity-provisioning/identity-provisioning.component.scss"],"names":[],"mappings":"AAAC;EACC,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACC,2CAAA;EACD,qDAAA;AACF;;AAEA;EACE,iCAAA;EACA,2CAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,wBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACD,gBAAA;AACD;;AAEA,mBAAA;AACA;EACE,yBAAA;EAEA,eAAA;EAEA,uBAAA;EACA,uCAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA,2BAAA;AACA;EACE;IACE,gBAAA;EADF;EAIA;IACE,eAAA;EAFF;EAKA;IACE,mBAAA;EAHF;EAMA;IACE,oBAAA;EAJF;AACF;AAOA;EACE;IACE,aAAA;EALF;EAQA;IACE,kBAAA;EANF;EASA;IACE,kBAAA;EAPF;EAUA;IACE,mBAAA;EARF;EAWA;IACE,WAAA;EATF;AACF","sourcesContent":[" .tool-card {\r\n  background: #ffffff;\r\n  border-radius: 0.75rem;\r\n  padding: 1.5rem;\r\n  text-align: center;\r\n   box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.tool-card:hover {\r\n  transform: translateY(-0.3125rem);\r\n  box-shadow: 0 5px 7px rgba(2, 56, 121, 0.6);\r\n}\r\n\r\n.card-icon {\r\n  font-size: 2.5rem;\r\n  color: #4a4a4a;\r\n  margin-bottom: 0.9375rem;\r\n}\r\n\r\n.tool-title {\r\n  font-size: 1.6rem;\r\n  font-weight: 600;\r\n  color: #000000;\r\n  margin-bottom: 0.625rem;\r\n  text-align: justify;\r\n}\r\n\r\n.tool-description {\r\n  font-size: 1rem;\r\n  color: #2c2c2c;\r\n  margin-bottom: 1.25rem;\r\n  line-height: 1.3;\r\n text-align: left;\r\n}\r\n\r\n/* Button Styling */\r\n.btn-open {\r\n  background-color: #0060d6;\r\n  // padding: 0.625rem 1.25rem;\r\n  font-size: 1rem;\r\n  // font-weight: bold;\r\n  border-radius: 0.375rem;\r\n  transition: background 0.3s ease-in-out;\r\n}\r\n\r\n.btn-open:hover {\r\n  background-color: #1a1a86;\r\n}\r\n\r\n/* Responsive Adjustments */\r\n@media (max-width: 768px) {\r\n  .tool-card {\r\n    padding: 1.25rem;\r\n  }\r\n\r\n  .card-icon {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .tool-title {\r\n    font-size: 1.375rem;\r\n  }\r\n\r\n  .tool-description {\r\n    font-size: 0.9375rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .tool-card {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .card-icon {\r\n    font-size: 1.75rem;\r\n  }\r\n\r\n  .tool-title {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .tool-description {\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .btn-primary {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
